import { z } from "zod";

export const companyUserSchema = z.object({
  id: z.number(),
  email: z.string().email(),
  role: z.number().min(0).max(2),
  name: z.string().nullish(),
  name_kana: z.string().optional(),
  department: z.string().optional(),
  position: z.string().optional(),
  phone_number: z.string().optional(),
});

export type CompanyUser = z.infer<typeof companyUserSchema>;
